import { svAuth } from './sv/auth';
import { svMedia } from './sv/media';
import { svProjects } from './sv/projects';
import { svSettings } from './sv/settings';
import { svShell } from './sv/shell';

// The Swedish catalogue (OQ-162). Its words follow domain/CONTEXT.md § Swedish UI terms.
export const sv = {
  common: {
    save: 'Spara',
    cancel: 'Avbryt',
    close: 'Stäng',
    delete: 'Ta bort',
    edit: 'Redigera',
    create: 'Skapa',
    loading: 'Laddar…',
    yes: 'Ja',
    no: 'Nej',
    on: 'På',
    off: 'Av',
    passwordTooWeak: 'Lösenordet är för svagt (minst {{min}} tecken)',
    passwordHint: 'Minst {{min}} tecken.',
    showPassword: 'Visa lösenordet',
    hidePassword: 'Dölj lösenordet'
  },
  language: {
    label: 'Språk',
    sv: 'Svenska',
    en: 'English',
    saveFailed: 'Kunde inte spara språket.'
  },
  shell: svShell,
  media: svMedia,
  auth: svAuth,
  settings: svSettings,
  projects: svProjects
};
